<template>
    <div>
        <div>
            <img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/ladybug/3.png" style="width: 100%" alt="">
        </div>
        <div class="info-father">
            <div class="index-div-content  product-info-div-no-padding">
                <div>
                    <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">产品功能</span>
                        <img
                                src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                </div>
                <div class="product_info">
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/cicada/10.png" width="140" alt=""></div>
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/cicada/11.png" width="140" alt=""></div>
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/cicada/15.png" width="140" alt=""></div>
                    <div><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/cicada/12.png" width="140" alt=""></div>
                </div>
            </div>
        </div>
        <product-info productInfo="ladybugProductInfo" productProvince="ladybugProvince"/>
        <div class="index-div-content  product-info-div-no-padding">
            <el-row type="flex" justify="center" class="margin-top-20 background-white product-info-div-flex">
                <el-col :xs="24" :sm="12"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/ladybug/4.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>4#角钢趴轨设计，重量最轻</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            机器人体积383x279x75mm，体重8.2KG，使用双4#角钢轨道，具有体积更小、重量更轻、性能更稳、效果更明显、成本更低等优点。
                        </p>
                    </div>

                </el-col>
            </el-row>
            <el-row type="flex"  justify="center" class="margin-top-20 background-white product-info-div-flex">
                <el-col :xs="24" :sm="0"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/ladybug/1.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>自主导航 自主定位</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            使用高精度电机里程计和RFID标签精准定位功能，自研底层智能导航算法技术，实现机器人全自主导航。
                        </p></div>
                </el-col>
                <el-col :xs="0" :sm="12"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/ladybug/1.png" style="width:100%" alt=""></el-col>
            </el-row>
            <el-row type="flex"  justify="center" class="margin-top-20 background-white product-info-div-flex">
                <el-col :xs="24" :sm="12"><img src="../../../assets/mk体育(中国)官方网站 - mk sports/product/info/ladybug/2.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>自主巡检 智能巡检</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            底层自研多种巡检模式，包括自主巡检、排班巡检、满电巡检多种巡检模式，满足不同场景的无人巡检功能。
                        </p></div>
                </el-col>
            </el-row>
        </div>
        <div class="background-white margin-top-20">
            <div id="maodian">
                <div class="index-div-content  product-info-div-no-padding   ">

                    <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">应用案例</span>
                        <img
                                src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                    <div>
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component video-url="https://mk体育(中国)官方网站 - mk sports-video.oss-cn-beijing.aliyuncs.com/video/01-%E6%A0%87%E5%87%86Ladybug-%E9%95%BF%E9%80%94%E8%BE%93%E9%80%81%E5%B8%A6-%E7%BA%A6%E5%9F%BA-%E5%B1%B1%E8%A5%BF%E6%96%87%E6%B0%B4.mp4"/>
                                    <div class="video-content">案例1：山西某长途输送带标准Ladybug机器人巡检</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component1 video-url="https://mk体育(中国)官方网站 - mk sports-video.oss-cn-beijing.aliyuncs.com/video/03-%E6%A0%87%E5%87%86Ladybug-%E9%95%BF%E9%80%94%E8%BE%93%E9%80%81%E5%B8%A6-%E9%B2%81%E4%B8%9C%E5%A4%A7%E5%AD%A6-%E7%83%9F%E5%8F%B0%E8%A5%BF%E5%B2%97.mp4"/>
                                    <div class="video-content">案例2：山东某长途输送带标准Ladybug机器人巡检</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="height: 20px">      </div>
                </div>
            </div>

        </div>

    </div>


</template>

<script>
    import VideoComponent from "../../commom/VideoComponent";
    import VideoComponent1 from "../../commom/VideoComponent";
    import ProductInfo from "../../commom/ProductInfo";
    export default {
        name: "ladybug",
        components:{VideoComponent,VideoComponent1,ProductInfo},
    }
</script>

<style scoped>

</style>